import { UserDTO } from "../DTO/userDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateUserRequest extends BasicRequest{

    public user! : UserDTO;

    constructor(){
        super()
    }
}